import type { ImageDTO } from '@neyara/shared';
import { Lotus } from './lotus';

/** Product photo, or a quiet champagne placeholder while the shoot is pending. */
export function SareeImage({
  image,
  name,
  className = '',
  sizes,
  eager = false,
}: {
  image: ImageDTO | undefined;
  name: string;
  className?: string;
  sizes?: string;
  eager?: boolean;
}) {
  if (!image) {
    return (
      <div
        className={`grid place-items-center bg-champagne text-gold-deep/70 ${className}`}
        role="img"
        aria-label={`${name} - photo coming soon`}
      >
        <div className="flex flex-col items-center gap-3 px-4 text-center">
          <Lotus className="h-8 w-12" />
          <span className="font-script text-lg italic">Photograph coming soon</span>
        </div>
      </div>
    );
  }
  return (
    <img
      src={image.url}
      alt={image.alt || name}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      sizes={sizes}
      className={`bg-champagne object-cover ${className}`}
    />
  );
}
